export const PLATFORM_ADMIN_ROLE = "platform_admin";

export const isPlatformAdminPayload = (payload) =>
  payload?.platformRole === PLATFORM_ADMIN_ROLE;

const VIEW_BY_ROLE = {
  admin: ["professional", "customer"],
  recruiter: ["professional", "customer"],
  professional: ["professional", "customer"],
  customer: ["customer"],
};

const PROFESSIONAL_FEATURE_ROLES = new Set(["professional", "recruiter", "admin"]);
const RECRUITER_FEATURE_ROLES = new Set(["recruiter", "admin"]);

export const canUseProfessionalFeatures = (role) =>
  PROFESSIONAL_FEATURE_ROLES.has(role);

export const canUseRecruiterFeatures = (role) =>
  RECRUITER_FEATURE_ROLES.has(role);

export const getAllowedViewsForRole = (role) =>
  VIEW_BY_ROLE[role] || VIEW_BY_ROLE.customer;

export const isRoleAllowedForView = (role, view) =>
  getAllowedViewsForRole(role).includes(view);

export const getDefaultViewForRole = (role) =>
  getAllowedViewsForRole(role)[0] || "customer";

export const getAllowedViewsForAuthPayload = (payload) => {
  const roleViews = getAllowedViewsForRole(payload?.role);
  const workspaceViews = payload?.businessWorkspaceAccess
    ? ["professional", ...roleViews]
    : roleViews;
  return isPlatformAdminPayload(payload)
    ? Array.from(new Set(["admin", ...workspaceViews]))
    : Array.from(new Set(workspaceViews));
};

export const getDefaultViewForAuthPayload = (payload) =>
  isPlatformAdminPayload(payload)
    ? "admin"
    : payload?.businessWorkspaceAccess
      ? "professional"
      : getDefaultViewForRole(payload?.role);
